module.exports = __webpack_public_path__ + "media/images/athletes/1675-d38377fec682c3bab89f45d1a957ecce.png";